import * as $ from 'jquery';

export function processSearchWords() {
  const hash = window.location.hash;
  if (hash.indexOf('#q=') === 0) {
    const searchWord = decodeURIComponent(window.location.hash.substring(3));

    // insensitive version of jQuery "contains"
    // @ts-ignore
    $.expr[':'].iContains = (a, i, m) => {
      return jQuery(a).text().toLowerCase()
        .indexOf(m[3].toLowerCase()) >= 0;
    };

    const $searchWordPanelContainers = $('#content .panel *:iContains(' + searchWord.toLowerCase() + ')');
    const $searchWordTabContainers = $('#content .tab-content *:iContains(' + searchWord.toLowerCase() + ')');

    $searchWordPanelContainers.each((elem) => {
      // search for accordions
      if ($searchWordPanelContainers[elem].classList.contains('panel-collapse')) {
        $($searchWordPanelContainers[elem]).parent().find('a.accordion-toggle').first().click();
      }
    });

    $searchWordTabContainers.each((elem) => {
      // search for tabs
      if ($searchWordTabContainers[elem].classList.contains('tab-pane')) {
        const tabId = $($searchWordTabContainers[elem]).attr('id');
        $($searchWordTabContainers[elem]).parent().parent().find('a[href$=\'#' + tabId + '\']').click();
        // break 'each' loop, because we found first tab
        return false;
      }
    });
  }
}
